import {
    Datagrid,
    DateField,
    ExportButton,
    List,
    SearchInput,
    TextField,
    TopToolbar,
} from 'react-admin';

const filters = [<SearchInput key="q" source="q" alwaysOn />];
const Actions = () => (
    <TopToolbar>
        <ExportButton />
    </TopToolbar>
);

export const SubscribersList = () => (
    <List
        resource="newsletter_subscribers"
        filters={filters}
        actions={<Actions />}
        sort={{ field: 'created_at', order: 'DESC' }}
        title="Newsletter Subscribers"
    >
        <Datagrid rowClick={false} bulkActionButtons={false}>
            <TextField source="email" />
            <TextField source="first_name" />
            <TextField source="last_name" />
            <DateField source="created_at" showTime />
            <DateField source="unsubscribed_at" showTime />
        </Datagrid>
    </List>
);
